import axios from 'axios';
import { API_BASE_URL } from './config';

const isTopLevelIaasProduct = (service) => {
  return service?.parent_service_id == null && service?.service_type !== 'domain';
};

export const getDashboardData = async () => {
  // Default values in case of errors
  let activeIaasProducts = [];
  let activeSaasProducts = [];
  let openTickets = [];
  let serverAvailability = {
    totalServers: 0,
    onlineServers: 0,
    offlineServers: 0,
    warningServers: 0,
    overallUptime: 100
  };
  let activeServers = [];

  try {
    // Fetch data for active IaaS products
    try {
      const activeIaasResponse = await axios.get(`${API_BASE_URL}/iaas-service/active`);
      activeIaasProducts = Array.isArray(activeIaasResponse.data)
        ? activeIaasResponse.data.filter(isTopLevelIaasProduct)
        : [];
    } catch (error) {
      console.error('Error fetching IaaS products:', error);
    }
    
    // Fetch data for active SaaS products
    try {
      const activeSaasResponse = await axios.get(`${API_BASE_URL}/saas-service/active`);
      activeSaasProducts = Array.isArray(activeSaasResponse.data) ? activeSaasResponse.data : [];
    } catch (error) {
      console.error('Error fetching SaaS products:', error);
    }
    
    // Fetch data for open tickets
    try {
      const openTicketsResponse = await axios.get(`${API_BASE_URL}/tickets/open`);
      openTickets = Array.isArray(openTicketsResponse.data) ? openTicketsResponse.data : [];
    } catch (error) {
      console.error('Error fetching open tickets:', error);
    }
    
    // Fetch data for server availability
    try {
      const serverAvailabilityResponse = await axios.get(`${API_BASE_URL}/udsinfra/status`);
      serverAvailability = serverAvailabilityResponse.data || serverAvailability;
    } catch (error) {
      console.error('Error fetching server availability:', error);
    }
    
    // Fetch active servers for additional details
    try {
      const activeServersResponse = await axios.get(`${API_BASE_URL}/udsinfra/active`);
      activeServers = Array.isArray(activeServersResponse.data) ? activeServersResponse.data : [];
    } catch (error) {
      console.error('Error fetching active servers:', error);
    }
    
    return {
      activeIaasProducts,
      activeSaasProducts,
      openTickets,
      serverAvailability,
      activeServers
    };
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    // Return default values instead of throwing
    return {
      activeIaasProducts,
      activeSaasProducts,
      openTickets,
      serverAvailability,
      activeServers
    };
  }
};
